/**
 * useCompanionSound — maps MindoraMood to companion sound types.
 * Only plays on mood *change*, not on initial mount.
 */

import { useCallback } from 'react';
import { useSoundEffects, type SoundType } from './useSoundEffects';
import type { MindoraMood } from '../components/character/MindoraCharacter';

const moodSoundMap: Partial<Record<MindoraMood, SoundType>> = {
  happy: 'happyHum',
  encouraging: 'encouragingMmHmm',
  celebrating: 'celebratoryWoohoo',
  surprised: 'gentleOh',
  waving: 'happyHum',
};

export function useCompanionSound() {
  const { play } = useSoundEffects();

  const playForMood = useCallback(
    (mood: MindoraMood) => {
      const sound = moodSoundMap[mood];
      if (sound) play(sound);
    },
    [play],
  );

  return { playForMood };
}
